export default "__VITE_ASSET__DjYT7TaX__"